import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["summary", "count", "hint"];
  static values = { required: Boolean };

  connect() {
    this.form = this.element.closest("form");
    this.updateCount();
    this.updateAriaExpanded();

    if (this.form && this.requiredValue) {
      this._onSubmit = this.onFormSubmit.bind(this);
      this.form.addEventListener("submit", this._onSubmit);
    }

    // Écoute les changements de la question
    this.element.addEventListener("change", (e) => {
      if (e.target?.classList?.contains("mc-checkbox")) {
        const first = this.firstCheckbox();
        if (first) {
          first.setCustomValidity("");
          first.removeAttribute("aria-invalid");
        }
        this.hideHint();
        this.updateCount();
        // ==> NEW : si valide, on enlève disabled du submit
        if (this.anyChecked()) this.enableSubmitIfPossible();
      }
    });

    // Si déjà des cases pré-cochées (back/forward), on réactive le bouton d’emblée
    if (this.anyChecked()) this.enableSubmitIfPossible();
  }

  disconnect() {
    if (this.form && this._onSubmit) this.form.removeEventListener("submit", this._onSubmit);
  }

  // ----- utils -----
  firstCheckbox() { return this.element.querySelector(".mc-checkbox"); }
  anyChecked() { return this.element.querySelector(".mc-checkbox:checked") !== null; }

  submitButton() {
    // on cherche le premier bouton de submit du même form
    return this.form?.querySelector('button[type="submit"], input[type="submit"]') || null;
  }

  enableSubmitIfPossible() {
    const btn = this.submitButton();
    if (!btn) return;
    // on ne fait que RÉ-ACTIVER (jamais désactiver)
    btn.disabled = false;
    btn.removeAttribute("disabled");
  }

  updateCount() {
    const count = this.element.querySelectorAll(".mc-checkbox:checked").length;
    if (this.hasCountTarget) this.countTarget.textContent = `${count} sélection(s)`;
  }

  hideHint() { if (this.requiredValue && this.hasHintTarget) this.hintTarget.style.display = "none"; }
  showHint() { if (this.requiredValue && this.hasHintTarget) this.hintTarget.style.display = "block"; }

  updateAriaExpanded() {
    if (this.hasSummaryTarget) {
      this.summaryTarget.setAttribute("aria-expanded", this.element.open ? "true" : "false");
    }
  }

  // (optionnel si tu as toujours data-action)
  toggled() { this.updateAriaExpanded(); }
  changed() { /* l'écouteur 'change' ci-dessus suffit déjà */ }

  onFormSubmit(e) {
    if (!this.requiredValue) return;

    if (!this.anyChecked()) {
      e.preventDefault();

      if (!this.element.open) this.element.open = true;

      const first = this.firstCheckbox();
      if (first) {
        const label = this.element.querySelector(".mc-question")?.textContent?.trim() || "cette question";
        first.setCustomValidity(`Sélectionnez au moins une option pour « ${label} ».`);
        first.setAttribute("aria-invalid", "true");
        first.reportValidity();
        first.focus();
      }
      this.showHint();

      // Affiche aussi les autres erreurs natives du formulaire
      if (this.form?.reportValidity) this.form.reportValidity();
    } else {
      // valide : on nettoie et on s'assure que le bouton est actif
      const first = this.firstCheckbox();
      if (first) { first.setCustomValidity(""); first.removeAttribute("aria-invalid"); }
      this.hideHint();
      this.enableSubmitIfPossible();
    }
  }
}
